import Vue from 'vue'
import Vuex from 'vuex'
import {ROISERVICE} from '../http-common';
import router from "../router";
import {vm} from "../main";
import VuexReset from '@ianwalter/vuex-reset'
Vue.use(Vuex)

const sortObjKeysAlphabetically = (obj) => Object.fromEntries(Object.entries(obj).sort());

export const store =  new Vuex.Store({
  plugins: [VuexReset()],
  state: {
    lang: 'de',
    loadingStatus: false,
    debug: false,
    errors: [],
    userRoles: [],
    initialQueryParams: {},
    roiCurrentStep: 1,
    roiSuperGroups: {},
    roiGroups: {},
    //roiStepsSchema: {},
    roiStepsSchema1: [],
    roiStepsSchema2: [],
    roiStepsSchema3: [],
    roiStepsSchema4: [],
    roiStepsValues: {
      "R_GROUP_0001": [],
      "R_GROUP_0002": [],
      "R_GROUP_0003": [],
      "R_GROUP_0004": [],
    },
    roiStepsValuesOld: {},
    roiServiceFilterBeforeChange: '',
    roiServiceFilter: '',
    roiStepsLoadingStatus: {
      "R_GROUP_0001": false,
      "R_GROUP_0002": false,
      "R_GROUP_0003": false,
      "R_GROUP_0004": false,
    },
    roiStepResultLoading: false,
    roiStepsValid: {
      "R_GROUP_0001": {
        hasData: false,
        valid: true,
        msg: ''
      },
      "R_GROUP_0002": {
        hasData: false,
        valid: true,
        msg: ''
      },
      "R_GROUP_0003": {
        hasData: false,
        valid: true,
        msg: ''
      },
      "R_GROUP_0004": {
        hasData: false,
        valid: true,
        msg: ''
      },
    },
    roiResultData: {}
  },
  getters: {
    roiCurrentStep: state => state.roiCurrentStep,
    roiSuperGroups: state => state.roiSuperGroups,
    roiGroups: state => state.roiGroups,
    roiStepsSchema: state => state.roiStepsSchema,
    roiStepsValues: state => state.roiStepsValues,
    roiResultData: state => state.roiResultData,
    errors: state => state.errors,
    debug: state => state.debug,
    lang: state => state.lang
  },
  mutations: {
    reset: () => {},
    SET_LANG(state,lang) {
      state.lang = lang
    },
    SET_LOADING_STATUS(state, status) {
      state.loadingStatus = status
    },
    SET_ERROR(state, error) {
      state.errors.push(error)
    },
    SET_USER_ROLES(state,payload) {
      state.userRoles = payload
    },
    SET_DEBUG(state,value) {
      if (value === 'true') {
        state.debug = true;
      } else {
        state.debug = false;
      }
    },
    SET_INITIAL_QUERY_PARAMS(state,query) {
      state.initialQueryParams = query
    },
    SET_ROI_CURRENT_STEP(state, pos) {
      state.roiCurrentStep = parseInt(pos)
    },
    SET_ROI_SUPER_GROUPS(state, data) {
      state.roiSuperGroups = data
    },
    SET_ROI_GROUPS(state, data) {
      Object.assign (state.roiGroups, {[data.id]: data})
    },
    SET_ROI_STEPS_SCHEMA(state, schema) {
      //state.roiStepsSchema = Object.assign({}, state.roiStepsSchema, schema);
      //Object.assign (state.roiStepsSchema, schema)
      state.roiStepsSchema1 = [schema['R_GROUP_0001']];
      state.roiStepsSchema2 = [schema['R_GROUP_0002']];
      state.roiStepsSchema3 = [schema['R_GROUP_0003']];
      state.roiStepsSchema4 = [schema['R_GROUP_0004']];
    },
    SET_ROI_RESULT_DATA(state, data) {
      state.roiResultData = data;
    },
    SET_ROI_STEPS_VALUES_INITIAL(state, data) {
      state.roiStepsValuesInitial = data;
    },
    ASSIGN_ROI_STEPS_VALUES(state, data) {
      state.roiStepsValues = Object.assign({}, state.roiStepsValues, data);
    },
    SET_ROI_STEPS_VALUES_OLD(state, data) {
      state.roiStepsValuesOld = data;
    },
    SET_ROI_SERVICE_FILTER(state, value) {
      state.roiServiceFilter = value;
    },
    SET_ROI_SERVICE_FILTER_BEFORE_CHANGE(state,value) {
      state.roiServiceFilterBeforeChange = value;
    },
    SET_ROI_STEPS_LOADING_STATUS(state,payload) {
      state.roiStepsLoadingStatus[payload.group] = payload.value;
    },
    SET_ROI_STEPS_VALID_STATUS(state,payload) {
      state.roiStepsValid[payload.group].valid = payload.valid;
      state.roiStepsValid[payload.group].msg = payload.msg;
    },
    SET_ROI_STEPS_VALID_HAS_DATA(state,payload) {
      state.roiStepsValid[payload.group].hasData = payload.hasData;
    },
    SET_ROI_STEP_RESULT_LOADING(state,value) {
      state.roiStepResultLoading = value;
    }
  },
  actions: {

    fetchAndSetRoiSuperGroups(context) {
      context.commit('SET_LOADING_STATUS',true)
      ROISERVICE.get( this.state.lang )
        .then(response => {
          context.commit('SET_ROI_SUPER_GROUPS', response.data['superGroups'])
          context.dispatch('fetchAndSetRoiGroups').then(() => {
            context.dispatch('updateStepsSchema').then(() => {
              context.commit('SET_LOADING_STATUS', false)
            })

          })
        })
        .catch(e => {
          context.commit('SET_ERROR', e)
        })
    },

    fetchAndSetRoiGroups(context, range = 'all') {

      return new Promise((resolve) => {

        let store = this;
        let superGroups = store.state.roiSuperGroups;
        let promisedEvents = [];
        let i = 1;

        superGroups.forEach(function(item){

          if (Object.prototype.hasOwnProperty.call(item, "id") && item.id.length ) {
            //promisedEvents.push(ROISERVICE.get( store.state.lang + '/' + item.id ));
            if (range === 'all' || (range !== 'all' && i >= range )) {
              promisedEvents.push(ROISERVICE.get( store.state.lang + '/' + item.id + '?filter=' + store.state.roiServiceFilter + '&debug=' + store.state.debug));
              context.commit('SET_ROI_STEPS_LOADING_STATUS', {
                group: item.id,
                value: true
              })
            }
            i++;
          }

        });

        Promise.all(promisedEvents)
          .then(async function (results) {
            results.forEach(function(item){
              context.commit('SET_ROI_GROUPS', item.data)
              context.commit('SET_ROI_STEPS_LOADING_STATUS', {
                group: item.data.id,
                value: false
              })
            });
            resolve()
          });

      })
    },

    fetchAndSetRoiResultData(context) {
      return new Promise((resolve, reject) => {
        context.commit('SET_ROI_STEP_RESULT_LOADING',true)
        ROISERVICE.get( this.state.lang + '/result/?filter=' + context.state.roiServiceFilter )
          .then(response => {
            context.commit('SET_ROI_RESULT_DATA', response.data)
            context.commit('SET_ROI_STEP_RESULT_LOADING',false)
            resolve()
          })
          .catch(e => {
            context.commit('SET_ERROR', e)
            reject()
          })
      })
    },

    updateStepsSchema(context) {

      let schema = [];

      for (const [index, data] of Object.entries(context.getters.roiGroups)) {

        schema[index] = {
          name: data.id,
          type: 'group',
        }

        let children = [];

        if(Object.prototype.hasOwnProperty.call(data, "filterSelections")) {

          data['filterSelections'].forEach((element, index) => {
            //console.log(index);

            let child = {};
            let optionsType = 'checkbox';

            switch (element.selectionType) {
              case 'SINGLE':
                optionsType = 'RadioButton';
                break;
              case 'MULTI_OR':
              case 'MULTI_AND':
                optionsType = 'Checkbox';
                break;
            }

            child.label = element.text.trim();
            child.name = element.featureCode;
            child.type = optionsType;

            if (Object.prototype.hasOwnProperty.call(element, "imageUrl") && element.imageUrl.length ) {
              child.imageUrl = element.imageUrl;
            }

            let options = {}
            element.options.forEach((option) => {
              options[option.id] = option.text;
            });
            child.options = options;


            children[index] = child;

          });
          schema[index]['children'] = children;

        } else {
          schema[index]['children'] = [];
        }

      }

      context.commit('SET_ROI_STEPS_SCHEMA', schema)

    },

    updateRoiStepsValues(context, value) {
      context.commit('ASSIGN_ROI_STEPS_VALUES', value);
    },

    forceSchemaUpdate(context, currentStep) {

      if(store.state.roiServiceFilter.length > 0 && !store.state.loadingStatus) {
        context.dispatch('cleanAllValuesAfterStep', currentStep).then(() => {
          context.dispatch('fetchAndSetRoiGroups', currentStep).then(() => {
            context.dispatch('updateStepsSchema').then(() => {
              context.dispatch('getValuesBackAfterStep', currentStep).then(() => {
                // be sure to update Schema again based on back values
                context.dispatch('fetchAndSetRoiGroups', currentStep + 1).then(() => {
                  context.dispatch('updateStepsSchema');
                });

              });
            });
          });
        });
      }

    },

    convertRoiStepsValuesToURLParams(context) {
      let params = {}
      for (let prop in context.getters.roiStepsValues) {

        let steps = context.getters.roiStepsValues[prop];
        //console.log(JSON.stringify(steps));
        let values = "";

        steps.forEach(function(item){
          let i = 0;
          for (let prop in item) {
            if(item[prop].length > 0) {
              if (i === 0) {
                values += prop + '-' + item[prop];
              } else {
                values += '.' + prop + '-' + item[prop];
              }
            }
            i++;
          }
        });

        params[prop] = values;
        params['Step'] = context.getters.roiCurrentStep;
        if (context.getters.debug) {
          params['Debug'] = context.getters.debug;
        }
        //console.log (context.getters.roiStepsValues[prop][0]);
      }
      return sortObjKeysAlphabetically(params);
    },
    convertURLParamsToRoiStepsValues(context,initial = false) {
      let query = context.state.route.query;

      if(initial) {
        query = context.state.initialQueryParams;
      }

      // set current step if in url
      if(Object.prototype.hasOwnProperty.call(query, "Step")){
        context.commit('SET_ROI_CURRENT_STEP',query.Step);
      }

      // set debug modus if in url
      if(Object.prototype.hasOwnProperty.call(query, "Debug")){
        context.commit('SET_DEBUG',query.Debug);
      }

      let queryParams = {};

      for (let propertyName in query) {

        if (propertyName.indexOf("R_GROUP") === 0) {
          queryParams[String(propertyName)] = [];
          let param = query[String(propertyName)];
          let objectProAndValues = {}
          //console.log(queryParams);
          if(param.length > 0) {
            let items = param.split(".");
            items.forEach(function(item){
              let itemSplitted = item.split(/-(.+)/);
              let value = itemSplitted[1];
              // for checkboxes we must build an array
              if (itemSplitted[1].includes(",")) {
                value = itemSplitted[1].split(",");
              }
              let temp = {
                [itemSplitted[0]]: value
              }

              Object.assign (objectProAndValues, temp);
            });
            //console.log (objectProAndValues);
            queryParams[propertyName].push(objectProAndValues);
          }
        }

      }
      //console.log(queryParams);
      return queryParams;

    },

    updateROIServiceFilter(context) {

      let data = context.state.roiStepsValues;
      let filter = '';

      // iterate over steps values and build filter for ROI Service
      for (let step in data) {
        if (data[step].length > 0) {
          //console.log(data[step]);
          data[step].forEach(function(group){
            if(vm.notEmptyObject(group)) {
              for (let item in group) {
                if (Array.isArray(group[item])) {
                  // array = checkboxes = e.g. // R_AGROUP0002-FEATURE_0002
                  group[item].forEach(function(checkbox) {
                    filter += item + '-' + checkbox + ',';
                  });
                } else {
                  // string = radio = e.g. R_AGROUP0001A-FEATURE_0002
                  filter += item + '-' + group[item] + ',';
                }
              }
            }
          });
        }
      }

      if (filter.length > 0 ) {
        filter = filter.slice(0, -1);
      }

      //console.log(filter);
      context.commit('SET_ROI_SERVICE_FILTER',filter);


    },

    cleanAllValuesAfterStep(context, cStep) {

      // save back current values first
      context.commit('SET_ROI_STEPS_VALUES_OLD',context.state.roiStepsValues);

      //console.log ('clean all after:' + cStep)

      let i = parseInt(cStep) + 1;
      let cStepValues = Object.keys(context.state.roiStepsValues).length;

      //console.log(i);



      if (i !== cStepValues + 1) {
        for (i; i <= cStepValues; i++) {
          if(Object.prototype.hasOwnProperty.call(context.state.roiStepsValues, "R_GROUP_000" + i)){
            let resetObject = {};
            resetObject['R_GROUP_000' +i] = [];
            //console.log(JSON.stringify(resetObject));
            context.commit('ASSIGN_ROI_STEPS_VALUES',resetObject);
          }

        }
      }

    },

    getValuesBackAfterStep(context, cStep) {



      let i = parseInt(cStep) + 1;
      let cStepValues = Object.keys(context.state.roiStepsValuesOld).length;

      //console.log ('get values back after:' + i);

      if (i !== cStepValues + 1) {
        for (i; i <= cStepValues; i++) {
          if(Object.prototype.hasOwnProperty.call(context.state.roiStepsValuesOld, "R_GROUP_000" + i)){

            let currentSchema = [];
            switch (i) {
              case 1:
                currentSchema =  context.state.roiStepsSchema1
                break;
              case 2:
                currentSchema =  context.state.roiStepsSchema2
                break;
              case 3:
                currentSchema =  context.state.roiStepsSchema3
                break;
              case 4:
                currentSchema =  context.state.roiStepsSchema4
                break;
            }

            let currentValues = context.state.roiStepsValuesOld['R_GROUP_000' + i];

            // build schemaArray for value comparison

            let schemaArray = [];

            if (currentSchema[0].children.length > 0) {
              currentSchema[0].children.forEach(function(item){
                schemaArray = schemaArray.concat(Object.keys(item.options));
              });
            }

            // clone object
            let newValues = currentValues;

            // compare and strip
            currentValues.forEach(function(item,indexParent){
              for (let prop in item) {
                let test = JSON.parse((JSON.stringify(item[prop])));
                //console.log (test);
                // Array vs single option !!!!
                if (Array.isArray(test)) {
                  test.forEach(function(itemToCheck){
                    //console.log (itemToCheck);
                    // if not found in schema
                    if (schemaArray.indexOf(itemToCheck) === -1) {
                      const findIndex = newValues[indexParent][prop].indexOf(itemToCheck);
                      if (findIndex > -1) {
                        newValues[indexParent][prop].splice(findIndex, 1);
                      }
                    }
                  });
                } else { // single checkbox case
                  if (schemaArray.indexOf(test) === -1) {
                    newValues[indexParent][prop] = '';
                  }
                }

              }
              //console.log(indexParent);
            });

            //console.log (JSON.stringify(currentValues));
            //console.log (JSON.stringify(newValues));


            let resetObject = {};
            resetObject['R_GROUP_000' +i] = newValues;

            //console.log(JSON.stringify(schemaArray));
            //console.log(JSON.stringify(resetObject));

            context.commit('ASSIGN_ROI_STEPS_VALUES',resetObject);
            // todo: maybe instead of cleaning all substep values we could only remove properties which are not in the affected step schema ?
          }

        }
      }

    },

    setInitialData(context) {
      context.dispatch('fetchAndSetRoiSuperGroups').then(() => {
        if(vm.notEmptyObject(context.state.initialQueryParams)) {
          context.dispatch('convertURLParamsToRoiStepsValues',true).then((valuesFromUrl) => {
            if (vm.notEmptyObject(valuesFromUrl))
            {
              context.commit('ASSIGN_ROI_STEPS_VALUES',valuesFromUrl);
            }
          })
        }
      })
    },

    resetStore(context) {
      context.commit('reset');
    },

    updateRoiStepsHasData(context,payload) {

      let hasData = false;

      if(payload.schema.length > 0) {
        if (typeof (payload.schema[0].children !== 'undefined') && payload.schema[0].children.length > 0) {
          hasData = true;
        }
      }

      store.commit('SET_ROI_STEPS_VALID_HAS_DATA', {
        group: payload.group,
        hasData: hasData
      })

    },

  },
})

store.watch((state) => state.roiStepsValues, () => {

    store.dispatch('convertRoiStepsValuesToURLParams').then((params) => {
      router.replace({
        query: params
      }).catch(err => {
        if (err.name !== "NavigationDuplicated") {
          throw err;
        }
      })
    })

    store.dispatch('updateROIServiceFilter');

  },
  {
    deep:true
  }
)


store.watch((state) => state.roiStepsSchema1, (schema) => {
  store.dispatch({
    type: 'updateRoiStepsHasData',
    schema: schema,
    group: 'R_GROUP_0001',
  })
})

store.watch((state) => state.roiStepsSchema2, (schema) => {
  store.dispatch({
    type: 'updateRoiStepsHasData',
    schema: schema,
    group: 'R_GROUP_0002',
  })
})

store.watch((state) => state.roiStepsSchema3, (schema) => {
  store.dispatch({
    type: 'updateRoiStepsHasData',
    schema: schema,
    group: 'R_GROUP_0003',
  })
})


store.watch((state) => state.roiStepsSchema4, (schema) => {
  store.dispatch({
    type: 'updateRoiStepsHasData',
    schema: schema,
    group: 'R_GROUP_0004',
  })
})


store.watch((state) => state.roiCurrentStep, (to, from) => {

    router.push({
      query: Object.assign({}, store.state.route.query, {Step: store.state.roiCurrentStep})
    }).catch(err => {
      if (err.name !== "NavigationDuplicated") {
        throw err;
      }
    })

  if ( store.state.roiServiceFilter !== store.state.roiServiceFilterBeforeChange)
  {
    // save back service filter status
    store.commit('SET_ROI_SERVICE_FILTER_BEFORE_CHANGE', store.state.roiServiceFilter);

    //console.log('from: ' + from + 'to: ' + to);

    if (to > from) {
      //console.log('step change schmea DEFAULT update from: ' + from )
      store.dispatch('forceSchemaUpdate', from);
    }

  }


  }
)
